<template>
  <div class="expert-card">
    <div class="expert-card__header">
      <div class="expert-card__avatar-container n-avatar">
      <div class="expert-card-avatar">

        <AppImage v-if="expert.personAvatar" :image="`https://navigator-backend.eurekacenter.ru/api/download/avatar/user/${expert.personAvatar}`" />

        </div>
      </div>
      <div class="expert-card__info">
        <h3 class="expert-card__name">
          {{ expert.lastname }} {{ expert.firstname }} {{ expert.secname }}
        </h3>
      </div>
    </div>
    
    <div class="expert-card__regalias" v-if="expert.personRegalias && expert.personRegalias.length > 0">
      <div 
        class="expert-card__regalia" 
        v-for="(regalia, index) in expert.personRegalias" 
        :key="index"
      >
        <h4 class="expert-card__regalia-title">{{ regalia.regaliaName }}</h4>
        <p class="expert-card__regalia-body" v-html="regalia.regaliaBody"></p>
      </div>
    </div>
  </div>
</template>

<script>
import AppImage from "@/elements/AppImage.vue"



export default {
        components: {
          AppImage
           },
  name: 'ExpertCard',
  props: {
    expert: {
      type: Object,
      required: true,
      default: () => ({
        firstname: '',
        secname: '',
        lastname: '',
        personAvatar: '',
        personRegalias: []
      })
    }
  },
  methods: {
    getInitials(firstname, secname, lastname) {
      let initials = '';
      if (lastname) initials += lastname.charAt(0).toUpperCase();
      if (firstname) initials += firstname.charAt(0).toUpperCase();
      if (secname) initials += secname.charAt(0).toUpperCase();
      return initials;
    }
  }
}
</script>

<style scoped>
.expert-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  margin: 15px 0;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.expert-card-avatar {
  width: 60px;
      height: 60px;

      &__pseudo-avatar {
        width: 100%;
        height: 100%;
        display: flex;

        justify-content: center;
      }
}


.expert-card__header {
  display: flex;

  margin-bottom: 15px;
  align-items: center;
  justify-content: center;
}

.expert-card__avatar-container {
  margin-right: 15px;
  flex-shrink: 0;
}

.expert-card__avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e0e0e0;
}

.expert-card__avatar-placeholder {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 24px;
  color: #666;
  border: 2px solid #e0e0e0;
}

.expert-card__info {
  flex: 1;

}


.expert-card__name {

  font-size: 18px;
  color: #333;

}

.expert-card__regalias {
  border-top: 1px solid #e0e0e0;
  padding-top: 15px;
}

.expert-card__regalia {
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.expert-card__regalia:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.expert-card__regalia-title {
  margin: 0 0 8px 0;
  font-size: 16px;
  color: #2c3e50;
  font-weight: 600;
}

.expert-card__regalia-body {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.expert-card__regalia-body :deep(p) {
  margin: 0 0 10px 0;
}

.expert-card__regalia-body :deep(p:last-child) {
  margin-bottom: 0;
}
</style>